var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DAA5F7B2-808E-47A9-9F12-616868175C10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Administrador-Pearson",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u27054.1-Desktop-HD/-mapa-abierto--Copy-32",
    transform: "translate(-898.000000, -286.000000)",
    fill: "#9051B1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(873.000000, 262.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7289879,25.4574185 C35.2976928,25.4574185 35.7587192,25.9125013 35.7587192,26.4738743 C35.7587192,27.0097304 35.3386517,27.4487394 34.805838,27.4875421 L34.7289879,27.4903302 L27.0317467,27.4903302 C26.7676355,27.4903302 26.5500763,27.6864627 26.5203439,27.9392743 L26.5168811,27.9985581 L26.5168811,41.7202032 C26.5168811,41.9809094 26.7155752,42.1956638 26.9716886,42.2250129 L27.0317467,42.2284311 L34.7289879,42.2284311 C35.2976928,42.2284311 35.7587192,42.6835138 35.7587192,43.2448869 C35.7587192,43.780743 35.3386517,44.2197519 34.805838,44.2585547 L34.7289879,44.2613427 L27.0317467,44.2613427 C25.6473262,44.2613427 24.5182625,43.1827974 24.4597968,41.8304381 L24.4574185,41.7202032 L24.4574185,27.9985581 C24.4574185,26.6319858 25.5500502,25.5174781 26.9200721,25.4597662 L27.0317467,25.4574185 L34.7289879,25.4574185 Z M38.8210574,27.2964643 L38.8865797,27.3558165 L44.755533,33.1445323 C45.0692484,33.4539587 45.13848,33.9134617 44.9631341,34.2891256 C45.2217908,34.6598855 45.2005764,35.1632999 44.9011048,35.5138782 L44.8409257,35.5785088 L38.9719724,41.3672246 C38.5696785,41.7640185 37.9176888,41.7637644 37.5157126,41.3666569 C37.134893,40.9904499 37.115081,40.3930283 37.4561087,39.9938021 L37.5162877,39.9291715 L41.6244185,35.8754185 L33.0336898,35.8755823 C32.464985,35.8755823 32.0039586,35.4204995 32.0039586,34.8591265 C32.0039586,34.3232704 32.424026,33.8842615 32.9568398,33.8454587 L33.0336898,33.8426707 L42.5484185,33.8424185 L37.430895,28.7938696 C37.0286012,28.3970758 37.0283437,27.7534916 37.4303199,27.3563842 C37.8111395,26.9801771 38.4163479,26.9601487 38.8210574,27.2964643 Z",
    id: "Combined-Shape-Copy-2",
    transform: "translate(34.800000, 34.859381) rotate(-90.000000) translate(-34.800000, -34.859381) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.6ad238e39a344dfcdc552c4596b9d7fd.svg";
export { ForwardRef as ReactComponent };